import PageToPrint from './page-to-print';

export default PageToPrint;